<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-home"
    >
        <y-container>
            <y-landing-hero
                :content="findPost('home1')"
                target-word="$word$"
                schedule-demo
            />
        </y-container>

        <div class="m-home__part-one-bg">
            <y-container>
                <y-call-to-action :content="findPost('home2')" />

                <y-why-choose-us :content="findPost('home3')" />

                <y-try-it-yourself
                    iframe
                    iframe-field="field1"
                    :content="findPost('home4')"
                />
            </y-container>
        </div>

        <y-container>
            <y-discover-services :content="findPost('home5')" />

            <y-our-clients-say
                :content="findPost('home6')"
                :clients-say="clientsSay"
                title-tag="h4"
            />
        </y-container>

        <div class="m-home__part-two-bg">
            <y-container>
                <y-boost-your-marketing :content="findPost('home7')" />

                <y-discover-power :content="findPost('home8')" />

                <y-latest-articles :articles="articles" />
            </y-container>
        </div>
    </div>
</template>

<script>
    import PageMixin from '@groot-nodes/mixins/Page.js';

    // Components
    import YLandingHero from '@components/LandingHero/Index.vue';
    import YCallToAction from '@modules/home/components/CallToAction/Index.vue';
    import YWhyChooseUs from '@modules/home/components/WhyChooseUs/Index';
    import YTryItYourself from '@modules/home/components/TryItYourself/Index.vue';
    import YDiscoverServices from '@modules/home/components/DiscoverServices/Index';
    import YOurClientsSay from '@components/OurClientsSay/Index';
    import YBoostYourMarketing from '@modules/home/components/BoostYourMarketing/Index';
    import YLatestArticles from '@modules/home/components/LatestArticles/Index';
    import YDiscoverPower from '@modules/home/components/DiscoverPower/Index';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    export default {
        name: 'HomePage',

        components: {
            YWhyChooseUs,
            YTryItYourself,
            YLandingHero,
            YCallToAction,
            YDiscoverServices,
            YOurClientsSay,
            YBoostYourMarketing,
            YLatestArticles,
            YDiscoverPower,
        },

        mixins: [PageMixin],

        /**
         * @inheritdoc
         */
        data() {
            return {
                home       : null,
                articles   : null,
                clientsSay : null,
                pageTitle  : this.$t('home.title'),
                heroContent: '',
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            removeSymbol,

            /**
             * Find post
             *
             * @param {string} slug
             * @returns {*}
             */
            findPost(slug) {
                return this.home.find((item) => item.slug === slug);
            },

            /**
             * Fetch home data
             *
             * @returns {Promise}
             */
            fetch() {
                const home = this.$services.Content.postList({
                    type     : 'home-page',
                    including: ['title', 'title2', 'synopsis', 'image', 'text', 'custom', 'slug', 'albums', 'seo_canonical', 'seo_meta_description', 'seo_post_title'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const clientsSay = this.$services.Content.postList({
                    type     : 'testimonials',
                    tagging  : 'home',
                    including: ['title', 'title2', 'header_image', 'image', 'synopsis'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const articles = this.$services.Content.postList({
                    type     : 'blog',
                    including: ['image', 'created_at', 'tagging_cats', 'title',
                                'synopsis', 'custom', 'user', 'publisher', 'time', 'url_encode', 'slug'],
                    limit : 3,
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([home, clientsSay, articles])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.home = responses[0].data.results;
                            this.heroContent = this.findPost('home1');
                        }
                        if (this.handleReq(responses, 1)) {
                            this.clientsSay = responses[1].data.results;
                        }
                        if (this.handleReq(responses, 2)) {
                            this.articles = responses[2].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    });
            },
        },
    };
</script>

<style lang="scss" src="../scss/home.scss" />
